import React from 'react'

const BillingReports = () => {
  return (
    <div className='mx-auto p-4'>
      BillingReports
    </div>
  )
}

export default BillingReports
